<template>
  <div class="empty-container">
      <img src="~@/assets/images/emptydata4.gif" alt="">
      <p>{{hint}}</p>
  </div>
</template>

<script>
export default {
  props: {
    hint: {
      type: String,
      default: 'TA还没有发布产品，让我们一起期待TA的产品吧！',
    },
  },
};
</script>

<style>

</style>
